interface ContactMethod {
  display: string;
  href?: string;
}

type ContactSupportMethodsType = 'supportHours' | 'phone' | 'email';

export const ContactSupportMethods: Record<
  ContactSupportMethodsType,
  ContactMethod
> = {
  supportHours: {
    display: '9AM-6PM ET',
  },
  phone: {
    display: '+1 (415) 610-5166',
    href: 'tel:+14156105166',
  },
  email: {
    display: 'support@clear.co',
    href: 'mailto:support@clear.co',
  },
};
